const handleDrawer = (state=false, action) => {
  switch (action.type) {
    case "CLOSEDRAWER":
      return { drawerState: false };
    case "OPENDRAWER":
      return { drawerState: true };
    default:
      return state;
  }
};

export default handleDrawer;
